import { ErrorHandler, Injectable } from '@angular/core';
import { isPageLeft } from './dashboard/ui-editor/ui-editor-services/page-run-scope.util';

/**
 * Suppress ONLY Angular's dev-mode NG0100 (ExpressionChangedAfterItHasBeenCheckedError) from the
 * console. NG0100 is a development-only change-detection assertion: it never runs in production builds
 * and never affects runtime behaviour (Angular keeps the new value and continues). It was firing on two
 * known-benign bindings — blockly-interface.html (`behaviorNav.pending`) + entity-list.html
 * (empty-state `*ngIf`). Requested 2026-06-30: hide the noise WITHOUT touching the bindings.
 *
 * Everything else is delegated to Angular's default ErrorHandler, so real failures (e.g. the query
 * TypeError) still log exactly as before — only the NG0100 line is dropped.
 *
 * Also dropped: a page function's `async group` stopped because the user navigated away (PageLeft). It runs
 * detached, so its stop arrives here as an unhandled rejection; it is the intended end, not a failure.
 */
@Injectable()
export class SilenceNg0100ErrorHandler implements ErrorHandler {
  private readonly base = new ErrorHandler();

  handleError(error: any): void {
    const message: string =
      (error && (error.message ?? error.toString?.() ?? String(error))) || '';
    // RuntimeError code 100 === NG0100; match the code or its human-readable name to be version-safe.
    if (
      (error && (error as any).code === 100) ||
      message.includes('NG0100') ||
      message.includes('ExpressionChangedAfterItHasBeenChecked')
    ) {
      return; // swallow — dev-only, harmless
    }
    if (isPageLeft(error)) return;
    this.base.handleError(error);
  }
}
